module.exports = __webpack_public_path__ + "img/Entia-Infraestructura-Ferroviaria-4.003997ea.webp";